
import { useEffect, useState } from 'react'
import { ZoomMtg } from "@zoom/meetingsdk"


const Zoom = () => {

  ZoomMtg.preLoadWasm()
  ZoomMtg.prepareWebSDK()

  const [zoomData, setZoomData] = useState()

  useEffect(() => {
    if (zoomData) {
      ZoomMtg.init({
        leaveUrl: '/',
        patchJsMedia: true,
        leaveOnPageUnload: true,
        success: (success) => {
          console.log(success)
          ZoomMtg.join({
            // signature: getSignature(),
            signature: zoomData.signature,
            meetingNumber: zoomData.meeting_number,
            userName: "Richard",
            sdkKey: zoomData.client_id,
            passWord: zoomData.password,
            // zak: zoomData.zak,
            success: (success) => {
              console.log(success)
            },
            error: (error) => {
              console.log(error)
            }
          })
        },
        error: (error) => {
          console.log(error)
        }
      })
    }
  }, [zoomData])

  const createMeeting = () => {
    $.ajax({
      method: 'POST',
      url: '/trainer/trainings/create_meeting',
      success: (response) => {
        setZoomData(response)
      }
    })
  }

  const base64UrlEncode = (str) => {
    return Buffer.from(str)
      .toString('base64')
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  };

  const getSignature = () => {
    let iat = Math.round(new Date().getTime() / 1000) - 300
    let data = {
      "appKey": zoomData.client_id,
      "mn": zoomData.meeting_number,
      "role": 1,
      "iat": iat,
      "exp": iat + 60 * 60 * 20,
      "tokenExp": iat + 60 * 60 * 20
    }

    console.log(data)

    const crypto = require('crypto');

    const header = JSON.stringify({ alg: 'HS256', typ: 'JWT' });
    const payload = JSON.stringify(data);

    const base64UrlHeader = base64UrlEncode(header);
    const base64UrlPayload = base64UrlEncode(payload);
    const signatureInput = `${base64UrlHeader}.${base64UrlPayload}`;

    const signature = crypto.createHmac('sha256', zoomData.client_id)
      .update(signatureInput)
      .digest('base64')
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');

    const jwt = `${signatureInput}.${signature}`;
    console.log(jwt)
    return jwt
  }

  return <>
    <a href="#" className="btn btn-themecolor" style={{position: 'absolute', zIndex: '99999'}} onClick={(e) => {e.preventDefault(); createMeeting()}}>Start</a>
  </>
}

export default Zoom